import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth/auth.service';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { ActivatedRoute, Router } from '@angular/router';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';

@Component({
  selector: 'app-UserRegistrationInvite',
  templateUrl: './UserRegistrationInvite.component.html',
  styleUrls: ['./UserRegistrationInvite.component.scss']
})

export class UserRegistrationInviteComponent implements OnInit {

  @ViewChild('firstname', {static: true}) firstname:ElementRef;

  titleAlert = 'This field is required';
  hide = true;

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  loginForm: FormGroup;
  ShowLoginForm:boolean=false;
  ShowLoginFormforMessage :boolean=false;
  ValidateUserInviteResponse :any;
  message:string="";
  EmailId:string="";
  phoneNumberExt = '+1';
  ContactId:string=""; 
  encryptedOfficeID:any;
  spinner:boolean=false;

  constructor(private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService, private authService: AuthService,
    private customValidator: CustomvalidationService,private router: Router,
    private activatedRoute: ActivatedRoute,private statusConstant: StatusConstant){    
        this.activatedRoute.queryParams.subscribe(params => {
        if (params.Email != undefined && params.Email != null
            && params.ContactID != undefined && params.ContactID != null) {
              this.EmailId = params.Email;
              this.organizationId = params.OrganizationID;
              this.ContactId =params.ContactID;
              this.encryptedOfficeID = params.OfficeID;
              this.ValidateUserInvite(params.Email,params.ContactID,params.OrganizationID,params.OfficeID)
        }
      });   
    }

  ngOnInit(): void {
    this.ShowLoginForm=false;
    this.ShowLoginFormforMessage=false;
    this.message="";
    let group = {};
    this.loginForm = new FormGroup(group);
    this.createRegistrationForm();
    //this.firstname.nativeElement.focus();
  }

  ValidateUserInvite(Email,ContactID,OrganizationID,OfficeID){
    var ReqModel = {
      email: encodeURIComponent(decodeURIComponent(Email)),//Email,
      contactID:  encodeURIComponent(decodeURIComponent(ContactID)),//ContactID,
      encryptedOrganizationID:  encodeURIComponent(decodeURIComponent(OrganizationID))//OrganizationID      
    }
    this.authService.ValidateUserInvite(ReqModel).subscribe(response=>{
      if (response) {       
        this.ValidateUserInviteResponse = response;
        if (this.ValidateUserInviteResponse.status == this.statusConstant.statusSuccess) {
        if(this.ValidateUserInviteResponse.data.isContactDoesNotExists==false
          && this.ValidateUserInviteResponse.data.isInvalidEmailOrContactID==false
          && this.ValidateUserInviteResponse.data.isUserExists==false)
          {
            this.ShowLoginForm=true;
            this.loginForm.controls.email.setValue(this.ValidateUserInviteResponse.data.contactEmail);  
            this.loginForm.controls['email'].disable();
            //this.firstname.nativeElement.focus();      
         }
            
         if(this.ValidateUserInviteResponse.data.isContactDoesNotExists==true
          && this.ValidateUserInviteResponse.data.isInvalidEmailOrContactID==false
          && this.ValidateUserInviteResponse.data.isUserExists==false)
          {
            this.ShowLoginFormforMessage=true;
            this.message = "Contact with this credentials does not exist.";          
          }

         if(this.ValidateUserInviteResponse.data.isContactDoesNotExists==false
          && this.ValidateUserInviteResponse.data.isInvalidEmailOrContactID==true
          && this.ValidateUserInviteResponse.data.isUserExists==false)
          {
            this.ShowLoginFormforMessage=true;
            this.message = "User or contact data is invalid.";          
          }

          if(this.ValidateUserInviteResponse.data.isContactDoesNotExists==false
            && this.ValidateUserInviteResponse.data.isInvalidEmailOrContactID==false
            && this.ValidateUserInviteResponse.data.isUserExists==true)
            {
              this.ShowLoginFormforMessage=true;
              this.message = "User already exist, Please login.";          
            }
        }
        else {
          
        }
      }
      else {        
      }
    });
  }

   // Create Registration form
   createRegistrationForm(): void {
    const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;

    this.loginForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],      
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(emailregex)]],     
      phoneNumber: ['', [Validators.required, Validators.pattern(phoneNumberregex)]],         
      password: ['', [Validators.required, this.customValidator.checkPassword.bind(this.customValidator)]],
      confirmPassword:  ['', [Validators.required, this.customValidator.checkPassword.bind(this.customValidator)]],
    },
    );
  }

      
  async SaveUserReg(data){
    this.spinner=true;
    var ReqModel = {
      userName: this.EmailId,//this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.EmailId),
      email: this.EmailId,//this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.EmailId),
      passwordHash: this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.password),
      phoneNumber: this.encryptionAlgo.set(this.reusableClass.encryptionKey, this.phoneNumberExt + '' + data.phoneNumber),
      twoFactorEnabled: true,
      firstName: this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.firstName),
      lastName: this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.lastName),
      contactID: encodeURIComponent(decodeURIComponent(this.ContactId)),
      encryptedOrganizationID: encodeURIComponent(decodeURIComponent(this.organizationId)),//this.organizationId
      encryptedOfficeID:  encodeURIComponent(decodeURIComponent(this.encryptedOfficeID)) 
    }
    const result = await this.authService.UserRegisterationInvite(ReqModel).subscribe(response=>{
    if (response.status ===  this.statusConstant.statusSuccess) {
      this.spinner=false;
      this.toastr.success("User registration successfully.", '', {
        timeOut: 3000,
      });
      this.router.navigate(['/auth/login']); 
    }
    else {      
      this.spinner=false;
    } 
  });
  }

  // Get Errors for email field
  getErrorEmail() {
    return this.customValidator.getErrorEmail(this.loginForm);
  }

  // Get Errors for password field
  getErrorPassword() {
    return this.customValidator.getErrorPassword(this.loginForm);
  }

   // Get Errors for phoneNumber field
   getPhoneErrorMessage() {
   return this.customValidator.getPhoneErrorMessage(this.loginForm);
  }


  Passwords(): void { 
    var password= this.loginForm.controls['password'].value.length;
    var confirmPassword= this.loginForm.controls['confirmPassword'].value.length;
    if(password >= 8 && confirmPassword >= 8){
     if (this.loginForm.controls['password'].value !== this.loginForm.controls['confirmPassword'].value) {
      this.loginForm.controls['password'].setErrors({ loginForm: true });       
     } else {       
       return null; 
     }
    }else{     
      this.loginForm.controls['password'].setErrors({ loginForm: true });      
    }      
   }


  // To match password on confirm password input box
  matchPassword(): void {    
    var password= this.loginForm.controls['password'].value.length;
    var confirmPassword= this.loginForm.controls['confirmPassword'].value.length;   
    if(password >= 8 && confirmPassword >= 8){
     if (this.loginForm.controls['password'].value !== this.loginForm.controls['confirmPassword'].value) {
       this.loginForm.controls['confirmPassword'].setErrors({ loginForm: true }); 
     } else {
       return null;
     }
    }else{
      this.loginForm.controls['confirmPassword'].setErrors({ loginForm: true });      
    }      
   }

  // To match password on confirm password input box
  // matchPassword(): void {   
  //   if (this.loginForm.controls['password'].value !== this.loginForm.controls['confirmPassword'].value) {
  //     this.loginForm.controls['confirmPassword'].setErrors({ loginForm: true });
  //   } else {
  //     return null;
  //   }
  // }

  /** Allow only Alphabet */
  allowAlphabetOnly(event) {
		const regexp = new RegExp('^[0-9!@#$&()\\-`.+,/\"]*$');
		const result = regexp.test(event.key);
		if (result) {
      this.titleAlert = 'Please enter only alphabets';
		  event.preventDefault();
		  return false;
		}
  }

  /** Allow only Number */
  allowOnlyNumber(event) {
		const regexp = new RegExp('^([0-9])$');
		const result = regexp.test(event.key);
		if (!result) {
		  event.preventDefault();
		  return false;
		}
  }
  
}
